import React from 'react'
import {
  PersonCard,
  PersonCardEmpty,
  ResourceInContent,
  PersonInContent,
  ResourcesTitle,
  ResourcesDetail,
  AproveController,
} from './styled'
import { getGlobalState } from '../../store'
import Approve from './Approve'
import { Flex, Box, Tooltip } from '@chakra-ui/core'
import AirportShuttleRoundedIcon from '@material-ui/icons/AirportShuttleRounded'
import Color from 'color'
import Actions from './Actions/'
const PersonComponent = (props) => {
  const authors = getGlobalState('users')
  const person = props.data
  const type = props.types ? props.types.find((t) => t._id === person.role) : {}
  const author = authors ? authors.find((t) => t._id === person.author) : {}
  if (props.viewType && props.viewType === 'resources') {
    return <PersonCardEmpty>{props.children}</PersonCardEmpty>
  }

  let needsTransportation = true

  if (
    props.data &&
    props.data.attr &&
    props.data.attr.transport &&
    props.data.attr.transport === '1'
  ) {
    needsTransportation = false
  }

  return (
    <PersonCard
      disabledrag={props.disabledrag ? 'true' : 'false'}
      willChange={props.willChange ? 'true' : 'false'}
      hasChanged={props.hasChanged ? 'true' : 'false'}
      approved={props.approved}
    >
      <PersonInContent>
        <div className="personTypeWrap">
          <span
            className="personType"
            style={{
              background: type ? type.color : '',
              display: 'inline-block',

              color:
                type && type.color
                  ? Color(type.color).isLight()
                    ? '#000000'
                    : '#ffffff'
                  : '#000000',
            }}
            onClick={() =>
              props.onClick && props.onClick(props.data._id, 'people')
            }
          >
            <div className="personTypeText">{type?.name || person?.code}</div>
          </span>
        </div>
        <div>
          <ResourcesTitle>
            <Flex
              style={{
                justifyContent: 'space-between',
                alignItems: 'flex-end',
              }}
            >
              <div
                className="name"
                onClick={() =>
                  props.onClick && props.onClick(props.data._id, 'people')
                }
                style={{
                  lineHeight: 1.2,
                }}
              >
                {person.firstName} {person.lastName}{' '}
                {needsTransportation && (
                  <AirportShuttleRoundedIcon
                    style={{
                      width: '13px',
                      height: '13px',
                      marginLeft: '.2em',
                    }}
                  />
                )}
                <br />
                <strong
                  style={{
                    fontSize: '0.8em',
                    color: '#676a7a',
                  }}
                >
                  {person.phone ? `${person.phone}` : ''}
                </strong>
                {person.currentUnavail ? (
                  <div>
                    <strong>{person.currentUnavail[2]}</strong>,{' '}
                    {person.currentUnavail[0]} -{person.currentUnavail[1]}
                  </div>
                ) : (
                  ''
                )}
              </div>
            </Flex>
          </ResourcesTitle>
          <Actions
            type={'person'}
            data={person}
            column={props.column}
            relataion={props.data.relationId}
            project={props.project}
            bottom={props.bottom}
          />
          {!props.simplified && author && (
            <div className="author" style={{ textAlign: 'right' }}>
              {author.firstName}
            </div>
          )}
          {props.approved === 'false' && (
            <Approve relationId={props.data.relationId} />
          )}

          {type && (
            <ResourcesDetail className={'pickerOnly'}>
              {type.name}
            </ResourcesDetail>
          )}
        </div>
      </PersonInContent>
      <div>{props.children}</div>
    </PersonCard>
  )
}

export default React.memo(PersonComponent, (prevProps, nextProps) => {
  return (
    prevProps.data._id === nextProps.data._id &&
    prevProps.approved === nextProps.approved &&
    prevProps.disabledrag === nextProps.disabledrag &&
    prevProps.willChange === nextProps.willChange &&
    prevProps.hasChanged === nextProps.hasChanged &&
    prevProps.children === nextProps.children
  )
})
